import ACTIONS from "../../constants/constants"

export const setHourglassState = toggle => ({
  type: ACTIONS.TOGGLE_HOURGLASS,
  toggle,
})
